<template>
    <div class="loader"></div>
</template>

<style lang="scss">
.loader {
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    font-size: 24px;
    color: var(--color-text);
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    background: rgba(256, 256, 256, .5);

    &::after {
        display: block;
        content: "";
        width: 50px;
        height: 50px;
        border: 5px solid #f3f3f3;
        border-top: 5px solid #fc4e88;
        border-radius: 50%;
        animation: spin 1s linear infinite;
    }
}
@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
</style>